<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GgD28O/tc-custom/9780253007025.jpg?1736422851765" alt="This image is the cover for the book Music in Kenyan Christianity, Ethnomusicology Multimedia"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Music in Kenyan Christianity, Ethnomusicology Multimedia
      </h1>
      <p class="bookDescription body article font2">
        <b>“The book contains an excellent mix of deep personal understanding of the culture and copious documentation.” —Eric Charry, Wesleyan University</b><br/><br/>This sensitive study is a historical, cultural, and musical exploration of Christian religious music among the Logooli of Western Kenya. It describes how new musical styles developed through contact with popular radio and other media from abroad and became markers of the Logooli identity and culture. Jean Ngoya Kidula narrates this history of a community through music and religious expression in local, national, and global settings. The book is generously enhanced by audiovisual material on the Ethnomusicology Multimedia website.<br/><br/>“The archival and ethnographic research is outstanding, the accounts of mission history, and then the musical explanations of a variety of forms of change that have accompanied mission intervention, the incursion of forms of modernity, and globalization at large are compelling and unparalleled.” —Carol Muller, University of Pennsylvania<br/><br/>“Explores contemporary African music through the prism of ethnographies through the people’s engagement of Christianity as a unifying ideology in the context of history, modernity, nationalisms and globalisation.” —<i>Journal of Modern African Studies</i><br/><br/>“The meticulous and sometimes highly sophisticated musical analyses, transcriptions, and the rich historical and ethnographic perspectives illuminate not only ongoing discourses and contestations of syncretism and related analytical notions, they also represent a plausible model of a balanced approach to ethnomusicology.” ?<i>International Journal of African Historical Studies</i><br/><br/>“An essential text for thinking about world Christianities, because it approaches a particular African Christianity from both insider and outsider perspectives.” —<i>Global Forum on Arts and Christian Faith</i><br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jean Ngoya Kidula
      </h2>
      
      <p class="authorDescription body article"><P>Jean Ngoya Kidula is Associate Professor of Music and Ethnomusicology at the Hugh Hodgson School of Music, University of Georgia. She is author (with R. R. King, T. Oduro, and J. R. Krabill) of Music in the Life of the African Church.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?18256791